import { getCookie } from 'utils/cookie.helper';
import { TApi } from 'utils/api';
import { TProjectConfigurationParameter } from 'entries/common/widgets/project-configuration/context';
import { ENDPOINTS } from '../../../const';
import { TCreateConfigurationBody, TEditConfigurationBody } from '../../../types';
import { setConfigurationIdCookie } from '../../../helpers/set-configuration-id-cookie';
import { dispatchProjectUpdatedCustomEvent } from '../../../helpers/dispatch-project-updated-custom-event';

type TFacet = {
  id: string;
  values: string[];
};

export const submitForm = async ({
  api,
  projectConfigurationCookieName,
  editConfigurationBody,
  createConfigurationBody,
  projectUpdatedCustomEventName,
  projectUpdatedCustomEventPayload,
}: {
  api: TApi;
  projectConfigurationCookieName: string;
  editConfigurationBody: TEditConfigurationBody;
  createConfigurationBody: TCreateConfigurationBody;
  projectUpdatedCustomEventName: string;
  projectUpdatedCustomEventPayload: {
    projectConfigurationParameters: Array<TProjectConfigurationParameter>;
    facets: TFacet[];
  };
}) => {
  const projectConfigurationId = getCookie(projectConfigurationCookieName);
  const isProjectCreated = Boolean(projectConfigurationId);
  if (isProjectCreated) {
    await api.patch(ENDPOINTS.EDIT_CONFIGURATION(projectConfigurationId as string), editConfigurationBody);
  } else {
    const res = await api.post(ENDPOINTS.CREATE_CONFIGURATION, createConfigurationBody);
    setConfigurationIdCookie({
      projectConfigurationId: res.projectConfigurationId,
      projectConfigurationCookieName,
    });
  }
  dispatchProjectUpdatedCustomEvent({ projectUpdatedCustomEventName, projectUpdatedCustomEventPayload });
};
